var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.64691 0C5.59425 0 6.3778 0.829393 6.50698 1.9078L12.8825 8.2832L7.03709 14.1286C6.15663 15.009 4.72915 15.009 3.8487 14.1286L0.660332 10.9402C-0.220111 10.0598 -0.220111 8.63227 0.660332 7.75181L2.76814 5.64401V2.22236C2.76814 0.994987 3.6093 0 4.64691 0ZM5.02266 2.22236V3.38949L4.27116 4.141V2.22236C4.27116 1.97689 4.43939 1.77789 4.64691 1.77789C4.85444 1.77789 5.02266 1.97689 5.02266 2.22236ZM5.02266 6.66708V5.51507L1.72312 8.81459C1.42964 9.10813 1.42964 9.58391 1.72312 9.87744L4.91149 13.0658C5.20498 13.3592 5.6808 13.3592 5.97429 13.0658L10.7568 8.2832L6.52569 4.05206V6.66708C6.52569 6.6994 6.52509 6.73156 6.52396 6.76358H5.0138C5.0196 6.73254 5.02266 6.70022 5.02266 6.66708Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1525 11.1758C10.2721 12.0563 10.2721 13.4838 11.1525 14.3642C12.033 15.2446 13.4605 15.2446 14.341 14.3642C15.2213 13.4838 15.2213 12.0563 14.341 11.1758L12.7467 9.58167L11.1525 11.1758Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.96f4219ea76a4f6a2fc7b189d99d5b4e.svg";
export { ForwardRef as ReactComponent };